/**
 * Payload the Dev adapter sends to `POST auth/mini-app`.
 * Env wins; otherwise the launch query (`miniappPayload` or `tgWebAppData`).
 */
export function resolveDevPayload(configured: string | null): string | null {
  const fromConfig = configured?.trim() || null
  if (fromConfig) {
    return fromConfig
  }
  return readPayloadFromLocation()
}

function readPayloadFromLocation(): string | null {
  if (typeof window === 'undefined') {
    return null
  }
  const params = new URLSearchParams(window.location.search)
  const fromQuery
    = params.get('miniappPayload')
      || params.get('tgWebAppData')
      || null
  if (!fromQuery?.trim()) {
    return null
  }
  // URLSearchParams.get already percent-decodes; do not decodeURIComponent again.
  return fromQuery.trim()
}

export function readStartParamFromLocation(): string | null {
  if (typeof window === 'undefined') {
    return null
  }
  const params = new URLSearchParams(window.location.search)
  return (
    params.get('startapp')
    || params.get('startParam')
    || params.get('tgWebAppStartParam')
    || null
  )
}
